import { Severity } from '../severity/severity.config';
import { type IconName } from '../lt-icon/lt-icon.config';

export type GrowlerStyle = 'floating' | 'default' | 'card';
export type DisplayPosition = 'top' | 'bottom' | 'inline';

export interface GrowlerConfig {
  id: string;
  severity: Severity;
  message: string;
  closeable: boolean;
  autoDismiss: boolean;
  title: string;
  icon: IconName;
  submit: boolean;
  submitType: 'link' | 'button' | string;
  submitButtonStyle: string;
  submitButtonIcon: IconName | '';
  submitLabel: string;
  submitted: (() => void) | null;
  items: string[];
  position: DisplayPosition | null;
  growlerStyle: GrowlerStyle;
  timeout: number | null;
  ariaLabel: string;
  showCloseButton: boolean;
  growlerClasses: string;
  targetSelector: string | null;
}

export const DEFAULT_GROWLER_CONFIG: Omit<
  GrowlerConfig,
  'id' | 'severity' | 'ariaLabel' | 'growlerClasses' | 'showCloseButton' | 'icon'
> = {
  message: '',
  closeable: true,
  autoDismiss: true,
  title: '',
  submit: false,
  submitType: 'link',
  submitButtonStyle: 'default',
  submitButtonIcon: '',
  submitLabel: '',
  submitted: null,
  items: [],
  position: null,
  growlerStyle: 'default',
  timeout: null,
  targetSelector: null
};
